var lists_default = {
  "fontElementMap": "bJ5vf",
  "orderedlist": "pmUuM",
  "bulletedlist": "evdas",
  "listItem": "qf5b9"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
